export default __webpack_public_path__ + "static/media/share.5f59bd65.svg";